module.exports = __webpack_public_path__ + "img/mail.a6904d92.svg";